import { ArrowRight, Check } from "lucide-react";
import { Button } from "../ui/button";
import SectionLogo from "../SectionLogo";

const GYM_SERVICES = ["On-site recovery days", "Member sessions", "Injury prevention", "Performance recovery"];

export const GymPartnershipsSection = ({ scrollToSection }) => {
  return (
    <section id="gym-partnerships" className="py-24 bg-[#0a0318] relative">
      <SectionLogo position="left" size="medium" opacity={0.05} />
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-2 mb-4">
              <span className="text-sm text-amber-300 font-medium">Gym Partnerships</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              <span className="text-amber-400">Gym</span> Partnerships
            </h2>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto">
              Add a premium recovery service to your gym and increase member retention.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div className="space-y-6">
              <h3 className="text-2xl font-bold text-white">Services</h3>
              <div className="grid grid-cols-1 gap-4">
                {GYM_SERVICES.map((item) => (
                  <div
                    key={item}
                    className="flex items-center gap-3 bg-[#110422]/50 border border-amber-500/20 rounded-lg p-4"
                  >
                    <Check className="w-5 h-5 text-amber-400 flex-shrink-0" />
                    <span className="text-gray-300">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-[#110422]/50 border border-amber-500/20 rounded-2xl p-8">
              <h3 className="text-2xl font-bold text-white mb-6">Pricing</h3>
              <div className="space-y-4">
                <div className="py-3">
                  <p className="text-white/70 text-sm mb-2">Pricing dependent upon treatment, customer and time.</p>
                  <p className="text-amber-400 font-semibold text-sm">
                    Monthly & multiple treatment packages available at 20% discount. Must be prepaid.
                  </p>
                </div>
              </div>
              <div className="mt-8">
                <Button
                  onClick={() => scrollToSection("booking")}
                  className="w-full bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-700 hover:to-amber-600 text-white py-6"
                  data-testid="gym-partnerships-book-btn"
                >
                  Partner With Us <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
